<script>
  import PlayButton from '../components/button-play.svelte'
  import {
    createEventDispatcher
  } from 'svelte';

  export let playing

  const dispatch = createEventDispatcher();
</script>


<button on:click="{() => dispatch('pressed', 'back')}" type="button" aria-label="Play">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="replay_10_24px">
      <path id="icon/av/replay_10_24px" fill-rule="evenodd" clip-rule="evenodd"
        d="M12 2V6C16.42 6 20 9.58 20 14C20 18.42 16.42 22 12 22C7.58 22 4 18.42 4 14H6C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14C18 10.69 15.31 8 12 8V12L7 7L12 2ZM10.05 17H10.9V12.73H10.81L9.04 13.36V14.05L10.05 13.74V17ZM15.18 15.24C15.18 15.56 15.15 15.84 15.08 16.06C15.01 16.28 14.91 16.48 14.79 16.63C14.67 16.78 14.51 16.89 14.34 16.96C14.17 17.03 13.97 17.06 13.75 17.06C13.53 17.06 13.34 17.03 13.16 16.96C12.98 16.89 12.83 16.78 12.7 16.63C12.57 16.48 12.47 16.29 12.4 16.06C12.33 15.83 12.29 15.56 12.29 15.24V14.5C12.29 14.18 12.32 13.9 12.39 13.68C12.46 13.46 12.56 13.26 12.68 13.11C12.8 12.96 12.96 12.85 13.13 12.78C13.3 12.71 13.5 12.68 13.72 12.68C13.94 12.68 14.13 12.71 14.31 12.78C14.49 12.85 14.64 12.96 14.77 13.11C14.9 13.26 15 13.45 15.07 13.68C15.14 13.91 15.18 14.18 15.18 14.5V15.24ZM14.29 13.9C14.32 14.03 14.33 14.19 14.33 14.38H14.32V15.35C14.32 15.54 14.3 15.7 14.28 15.83C14.26 15.96 14.22 16.07 14.17 16.15C14.12 16.23 14.05 16.29 13.98 16.32C13.91 16.35 13.82 16.37 13.73 16.37C13.64 16.37 13.56 16.35 13.48 16.32C13.4 16.29 13.34 16.23 13.29 16.15C13.24 16.07 13.2 15.96 13.17 15.83C13.14 15.7 13.13 15.54 13.13 15.35V14.38C13.13 14.19 13.14 14.03 13.17 13.9C13.2 13.77 13.24 13.67 13.29 13.59C13.34 13.51 13.41 13.45 13.48 13.42C13.55 13.39 13.64 13.37 13.73 13.37C13.82 13.37 13.9 13.39 13.98 13.42C14.06 13.45 14.12 13.51 14.17 13.59C14.22 13.67 14.26 13.77 14.29 13.9Z"
        fill="#333333" />
    </g>
  </svg>
</button>
<PlayButton {playing} on:pressed="{() => dispatch('pressed', 'play')}" />
  <div style="width:40px; height:40px; display: inline-block;">

  </div>
  <button style="display: none;" on:click="{() => dispatch('pressed', 'forward')}" type="button" aria-label="Play">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g id="forward_10_24px">
        <path id="icon/av/forward_10_24px" fill-rule="evenodd" clip-rule="evenodd"
          d="M12 20C15.31 20 18 17.31 18 14H20C20 18.42 16.42 22 12 22C7.58 22 4 18.42 4 14C4 9.58 7.58 6 12 6V2L17 7L12 12V8C8.69 8 6 10.69 6 14C6 17.31 8.69 20 12 20ZM10.9 12.73V17H10.05V13.74L9.04 14.05V13.36L10.81 12.73H10.9ZM14.32 12.78C14.14 12.71 13.95 12.68 13.73 12.68C13.51 12.68 13.32 12.71 13.14 12.78C12.96 12.85 12.81 12.96 12.69 13.11C12.57 13.26 12.46 13.45 12.4 13.68C12.34 13.91 12.3 14.18 12.3 14.5V15.24C12.3 15.56 12.34 15.84 12.41 16.06C12.48 16.28 12.58 16.48 12.71 16.63C12.84 16.78 12.99 16.89 13.17 16.96C13.35 17.03 13.54 17.06 13.76 17.06C13.98 17.06 14.17 17.03 14.35 16.96C14.53 16.89 14.68 16.78 14.8 16.63C14.92 16.48 15.02 16.29 15.09 16.06C15.16 15.83 15.19 15.56 15.19 15.24V14.5C15.19 14.18 15.15 13.9 15.08 13.68C15.01 13.46 14.91 13.26 14.78 13.11C14.65 12.96 14.49 12.85 14.32 12.78ZM14.29 15.83C14.32 15.7 14.33 15.54 14.33 15.35H14.34V14.38C14.34 14.19 14.33 14.03 14.3 13.9C14.27 13.77 14.23 13.67 14.18 13.59C14.13 13.51 14.06 13.45 13.99 13.42C13.92 13.39 13.83 13.37 13.74 13.37C13.65 13.37 13.57 13.39 13.49 13.42C13.41 13.45 13.36 13.51 13.3 13.59C13.24 13.67 13.21 13.77 13.18 13.9C13.15 14.03 13.14 14.19 13.14 14.38V15.35C13.14 15.54 13.15 15.7 13.18 15.83C13.21 15.96 13.25 16.07 13.3 16.15C13.35 16.23 13.42 16.29 13.49 16.32C13.56 16.35 13.65 16.37 13.74 16.37C13.83 16.37 13.91 16.35 13.99 16.32C14.07 16.29 14.13 16.23 14.18 16.15C14.23 16.07 14.26 15.96 14.29 15.83Z"
          fill="#333333" />
      </g>
    </svg>
  </button>


<style>
  button {
    position: relative;
    top: 10px;
    left: 0;
    padding: 16px;
    background: #FDFFFC;
    border: 2px solid #202020;
    box-shadow: 4px 4px 0px #FF9F1C;
    border-radius: 20px;
    transition: 0.1s;
    outline: none;
    max-width: 40px;
    max-height: 40px;
  }

  button:hover,
  button:focus {
    top: 12px;
    left: 2px;
    box-shadow: 2px 2px 0px #FF9F1C;
  }

  button:active {
    top: 14px;
    left: 4px;
    box-shadow: 0px 0px 0px;
  }

  svg {
    position: relative;
    top: -10px;
    left: -10px;
  }
</style>
